import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const ArrowBottomLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M12 3L12 21M12 21L19 14M12 21L5 14", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
ArrowBottomLine.iconName = 'arrow-bottom';
ArrowBottomLine.displayName = 'ArrowBottomLine';
export default ArrowBottomLine;
